import Player from 'https://cdn.skypack.dev/@vimeo/player';

export default class VimeoVideo  extends HTMLElement {
  constructor () {
    super()

    this.videoId = this.dataset.videoId
    this.player = this.initialisePlayer()
  }

  initialisePlayer () {
    return new Player(this, {
      id: this.videoId,
      loop: true,
      controls: false,
    })
  }

  async play () {
    if (!(await this.getPaused())) return // If the video is already playing, don't play it again
    this.player.play()
  }

  async pause () {
    if (await this.getPaused()) return // If the video is already paused, don't pause it again
    this.player.pause()
  }

  async getPaused () {
    return this.player.getPaused()
  }
}

if (!customElements.get('vimeo-video')) {
  customElements.define('vimeo-video', VimeoVideo)
}
